<template>
  <div class="customer">
    <div class="l">
      <p>
        {{ $t("home").customer.text0[0] }}<br />
        {{ $t("home").customer.text0[1] }}
      </p>
    </div>
    <div class="c">
      <div>
        <img src="../assets/ycb/h1.png" alt="" />
      </div>
      <div class="btn" @click="gotoPro(1)">
        {{ $t("btn") }}
      </div>
    </div>
    <div class="r">
      <div>
        <img src="../assets/ycb/h2.png" alt="" />
      </div>
      <div class="btn" @click="gotoPro(2)">
        {{ $t("btn") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customer",
  data() {
    return {};
  },
  methods: {
    gotoPro(i) {
      if (this.$i18n.locale == "en") {
        const link = `/pro.html?id=${i + 11}`;
        window.open(link, "_self");
      } else {
        const link = `/pro.html?id=${i + 111}`;
        window.open(link, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  width: 60%;
  margin: 60px auto;
  margin-top: 80px;
  animation-duration: 3s;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .l {
    width: 32%;
    height: 341px;
    background: rgba(38, 51, 70, 1);
    p {
      color: white;
      font-size: 33px;
      font-family: "DINEngschriftStd";
      text-transform: uppercase;
      width: 80%;
      line-height: 45px;
      margin: 40px auto;
      padding: 40px 0;
      position: relative;
      &::after {
        content: "";
        width: 48px;
        height: 1px;
        background: rgba(28, 139, 72, 1);
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
  .l,
  .c,
  .r {
    width: 32%;
    height: 341px;
  }
  .c,
  .r {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
    .btn {
      width: 50%;
      height: 40px;
      border: 1px solid rgba(145, 145, 145, 1);
      border-radius: 20px;
      transition: all 600ms;
      margin: 40px auto;
      line-height: 40px;
      text-transform: uppercase;
      font-family: "it";
      cursor: pointer;
      text-align: center;
      &:hover {
        background-color: #1c8b48;
        color: white;
      }
    }
  }
  @media screen and (max-width: 1440px) {
    width: 90%;
  }
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    .l {
      height: 200px;
      p {
        font-size: 30px;
        margin: 0 auto;
      }
    }
    .l,
    .c,
    .r {
      width: 100%;
      margin-bottom: 30px;
    }
  }
}
</style>
